import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import { fetchOrganization, updateOrganization } from '@/api/organization/organizationApi';
import type { Organization, OrganizationUpdate } from '@/api/organization/organizationApi.types';
import { ORGANIZATION_QUERY_KEY } from '@/constants/queryKeys';

export function useOrganizationQuery(isEnabled: boolean): UseQueryResult<Organization, Error> {
  return useQuery({
    queryKey: ORGANIZATION_QUERY_KEY,
    queryFn: fetchOrganization,
    enabled: isEnabled,
  });
}

export function useUpdateOrganizationMutation(): UseMutationResult<
  Organization,
  Error,
  OrganizationUpdate
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function submitOrganization(update: OrganizationUpdate) {
      return updateOrganization(update);
    },
    onSuccess: function updateCache(organization: Organization) {
      queryClient.setQueryData(ORGANIZATION_QUERY_KEY, organization);
    },
  });
}
